import React, { useState, useEffect } from 'react';
import loginImg from 'asset/image/img_login@2x.png';
import { useDispatch } from 'react-redux';
import styles from './index.module.scss';
import LoginWithCodeWrapper from './component/LoginWithCodeWrapper';
import LoginWithQRCodeWrapper from './component/LoginWithQRCodeWrapper';
import LoginWithPassword from './component/LoginWithPassword';
import LoginWithPasswordPriv from './component/LoginWithPasswordPriv';
import { getWeChatToken, resetLoginStatus } from 'model/login';
import WithPrivateCheck from 'component/WithPrivateCheck';
import { LoginType } from 'constant/auth';
import LoginTypeSwitch from 'component/AuthForm/LoginTypeSwitch';

const Login: React.FC = () => {
  const dispatch = useDispatch();
  const [type, setType] = useState<LoginType>(LoginType.MOBILE);
  const [isWxRedirect, setIsWxRedirect] = useState(false);

  useEffect(() => {
    if (window.location.search.includes('accessToken=')) {
      dispatch(getWeChatToken());
      setType(LoginType.QR_CODE);
      setIsWxRedirect(true);
    }
  }, []);

  const toggleLoginType = (type: LoginType) => {
    dispatch(resetLoginStatus());
    setType(type);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.banner}>
          <img src={loginImg} />
        </div>
        <div className={styles.loginContainer}>
          <div className={styles.title}>
            MAXHUB 会议预约系统{' '}
            <WithPrivateCheck>
              <div className={styles.priv_title}>- 本地部署 -</div>
            </WithPrivateCheck>
          </div>
          <WithPrivateCheck hide>
            {type === LoginType.MOBILE && <LoginWithCodeWrapper />}
            {type === LoginType.PASSWORD && <LoginWithPassword />}
            {type === LoginType.QR_CODE && <LoginWithQRCodeWrapper isWxRedirect={isWxRedirect} setIsWxRedirect={setIsWxRedirect} />}
          </WithPrivateCheck>
          <WithPrivateCheck>
            <LoginWithPasswordPriv />
          </WithPrivateCheck>
          <WithPrivateCheck hide>
            <LoginTypeSwitch type={type} onChange={toggleLoginType}></LoginTypeSwitch>
          </WithPrivateCheck>
        </div>
      </div>
    </div>
  );
};

export default Login;
